var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63791 3.43383L12.3779 12.0048L3.70291 20.6548C3.56134 20.4698 3.45121 20.2627 3.37691 20.0418C3.3379 19.7917 3.3379 19.537 3.37691 19.2868V4.56683C3.35091 4.17183 3.44191 3.77683 3.63691 3.43383M16.1429 8.26683L13.2899 11.0928L4.65391 2.59983C4.93391 2.50283 5.23391 2.47583 5.52691 2.52183C5.98691 2.64783 6.42591 2.84183 6.82891 3.09483L14.6449 7.41983C15.1529 7.69283 15.6479 7.97983 16.1429 8.26683ZM13.2909 12.9298L16.1299 15.7178L14.0719 16.8638L7.79291 20.3538C7.27291 20.6408 6.75091 20.9148 6.24291 21.2278C6.02559 21.3633 5.78184 21.4508 5.52798 21.4844C5.27412 21.518 5.01601 21.497 4.77091 21.4228L13.2909 12.9298ZM20.6509 12.0048C20.6588 12.3546 20.5706 12.6999 20.3961 13.0031C20.2216 13.3063 19.9673 13.5559 19.6609 13.7248L17.3149 15.0268L14.2279 12.0048L17.3279 8.93083C18.1229 9.37383 18.9049 9.81683 19.6859 10.2338C19.9976 10.4077 20.2535 10.6664 20.4241 10.9799C20.5948 11.2933 20.674 11.6487 20.6509 12.0048Z",
    fill: "#EEF0FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.1adb0505bb1953c384fe57b1c68a5e55.svg";
export { ForwardRef as ReactComponent };